import classNames from 'classnames'
import React from 'react'

import s from './index.scss'
import Logo1 from './logo1.svg'
import Logo2 from './logo2.svg'
import Logo3 from './logo3.svg'
import Logo4 from './logo4.svg'
import Logo5 from './logo5.svg'
import Logo6 from './logo6.svg'

export const EnterpriseLogos = ({ isResponsive = false }: { isResponsive?: boolean }) => (
  <div className={classNames(s.EnterpriseLogos, { [s.EnterpriseLogos_responsive]: isResponsive })}>
    <div>
      <Logo1 width="41px" height="auto" />
    </div>
    <div>
      <Logo5 width="152px" height="auto" />
    </div>
    <div>
      <Logo6 width="63px" height="auto" />
    </div>
    <div>
      <Logo4 width="63px" height="auto" />
    </div>
    <div>
      <Logo2 width="57px" height="auto" />
    </div>
    <div>
      <Logo3 width="75px" height="auto" />
    </div>
  </div>
)
